import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {AlertTriangle, Users} from 'lucide-react';

function getTargetDate() {
  const now = new Date();
  const target = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return target;
}

function formatDate(date: Date) {
  const months = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

  return `${date.getDate()} de ${months[date.getMonth()]}`;
}

const TARGET = getTargetDate();

export default function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const diff = TARGET.getTime() - now;
      if (diff <= 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(diff % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const pad = (n: number) => String(n).padStart(2, "0");

  return (
    <section className="bg-red-50 py-16 md:py-20 border-y-2 border-red-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center">

          <div className="flex items-center justify-center gap-2 mb-4">
            <AlertTriangle className="w-8 h-8 text-red-600" />
            <h2 className="font-serif-display text-3xl md:text-4xl font-bold text-red-600">ATENÇÃO: MUDANÇA DE PREÇO

            </h2>
          </div>

          <p className="text-gray-700 text-lg mb-2">
            A oferta com esse valor finaliza em <span className="font-bold text-blue-900">{formatDate(TARGET)}</span>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-gray-700 mb-8">
            <span>• Não garantimos esse mesmo preço</span>
            <span>• Acompanhamento ao vivo só para próximo bimestre</span>
            <span>• Acesso à Lucy IA limitado</span>
          </div>

          {/* Cronometro */}
          <div className="flex items-center justify-center gap-3 md:gap-5 mb-10">
            {[
            { value: pad(timeLeft.days), label: "DIAS" },
            { value: pad(timeLeft.hours), label: "HORAS" },
            { value: pad(timeLeft.minutes), label: "MIN" },
            { value: pad(timeLeft.seconds), label: "SEG" }].
            map((item, i) =>
            <div key={i} className="flex flex-col items-center">
                <div className="bg-white border-2 border-red-300 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-md">
                  <span className="text-2xl md:text-3xl font-bold text-blue-900">
                    {item.value}
                  </span>
                </div>
                <span className="text-xs font-semibold text-red-600 mt-1.5">{item.label}</span>
              </div>
            )}
          </div>

          {/* Prova social de demanda */}
          <div className="flex flex-col items-center gap-4 mb-8">
            <div className="flex -space-x-3">
              {[
              "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=100",
              "https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=100",
              "https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg?auto=compress&cs=tinysrgb&w=100",
              "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=100",
              "https://images.pexels.com/photos/1542085/pexels-photo-1542085.jpeg?auto=compress&cs=tinysrgb&w=100",
              "https://images.pexels.com/photos/712513/pexels-photo-712513.jpeg?auto=compress&cs=tinysrgb&w=100"].
              map((src, i) =>
              <img
                key={i}
                src={src}
                alt="aluno"
                className="w-10 h-10 rounded-full border-2 border-white object-cover shadow" />

              )}
              <div className="w-10 h-10 rounded-full bg-blue-900 border-2 border-white flex items-center justify-center shadow">
                <span className="text-white text-xs font-bold">+847</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Users className="w-5 h-5 text-blue-900" />
              <p className="text-blue-900 font-bold">
                847 alunos já garantiram sua vaga esse mês
              </p>
            </div>
          </div>

          <a
            href="#cta-final"
            onClick={(e) => { e.preventDefault(); document.getElementById('cta-final')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="cta-button inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-lg md:text-xl px-10 py-5 rounded-xl shadow-lg shadow-red-600/30 hover:shadow-red-600/50 transition-all duration-300 hover:scale-105 cursor-pointer">

            <span className="text-2xl">👉</span> GARANTIR MINHA VAGA
          </a>
        </motion.div>
      </div>
    </section>);

}